import SwipeDots from './SwipeDots.jsx';
export default SwipeDots;